<template>
  <div class="vue-dropdown default-theme" v-show-extend="show">
    <p class="search-module clearfix" v-show="length">
      <input id='dropdownInput' ref="inputKey" class="search-text"
             @input='search($event)' @keyup.enter='search($event)' :placeholder="placeholder"/>
      <span class="glyphicon glyphicon-search search-icon"></span>
    </p>
    <ul class="list-module" v-show="length">
      <li v-for ="(item,index) in datalist" @click="appClick(item)"
          :key="index">
        <div class="list-item-text">{{item.name}}</div>
      </li>
    </ul>
    <p class="tip__nodata" v-show="!datalist.length">{{nodatatext}}</p>
  </div>
</template>
<script>
export default {
  name: 'dropdown',
  data () {
    return {
      datalist_: this.itemlist.concat(),
      datalist: this.itemlist.concat(),
      length: this.itemlist.length
    }
  },
  props: {
    'show': {// 用于外部控制组件的显示/隐藏
      type: Boolean,
      default: true
    },
    'itemlist': Array,
    'placeholder': String,
    'nodatatext': String
  },
  directives: {
    'show-extend': function (el, binding, vnode) { // bind和 update钩子
      let value = binding.value
      let searchInput = null
      if (value) {
        el.style.display = 'block'
      } else { // 隐藏后，恢复初始状态
        el.style.display = 'none'
        searchInput = el.querySelector('.search-text')
        searchInput.value = ''
        vnode.context.datalist = vnode.context.itemlist// 还原渲染数据
      }
    }
  },
  methods: {
    appClick: function (data) {
      this.$emit('setCityValue', data)
      this.$refs.inputKey.value = ''
      this.datalist = this.itemlist
    },
    search: function (e) {
      let vm = this
      let searchvalue = e.currentTarget.value
      vm.datalist = vm.$data.datalist_.filter(function (item, index, arr) {
        return item.name.indexOf(searchvalue) !== -1
      })
    }
  },
  mounted: function () {
  },
  watch: {
    itemlist (newValue, oldValue) {
      this.datalist_ = newValue.concat()
      this.datalist = newValue.concat()
      this.length = newValue.length
    }
  }
}
</script>
<style lang="scss" scoped>
  .vue-dropdown.default-theme {
    position: absolute;
    left:30%;
    display: none;
    width: 70%;
    /*margin: 0 auto;
    margin-top: 1em;
    padding: 1em;*/
    z-index:10;
    box-shadow: 0px 0px 10px #ccc;
    &._self-show {
      display: block!important;
    }
    .search-module {
      position: relative;
      background: #F4FAFF;
      text-align: center;
      .search-text {
        width: 99.8%;
        height: 30px;
        /*padding-right: 2em;
        padding-left:0.5em;
        border-radius: 0.2em;*/
        box-shadow: 0px 1px 2px  #E6E6E6;
        border: 1px solid #E6E6E6;
        &:focus {
          border-color: #3485fa;
        }
      }
      .search-icon {
        position: absolute;
        top: 24%;
        right: 0.5em;
        color: #3485fa;
      }
    }
    .list-module {
      max-height: 10rem;
      overflow-y: auto;
      background: #F4FAFF;
      li {
        &._self-hide {
          display: none;
        }
        margin-top: 0.5em;
        padding: 0.5em;
        &:hover {
          cursor:pointer;
          color: #fff;
          background: #3485fa;
        }
      }
    }
  }
  .tip__nodata {
    font-size: 14px;
    margin-top: 1em;
    background: #FAFAFA;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/mydropdown.vue